/**
 * @generated SignedSource<<29aedd0092f9807ab3c19caf1d8ba604>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type routeSpaceQuery$variables = {
  club: string;
  space: string;
};
export type routeSpaceQuery$data = {
  readonly club: {
    readonly space: {
      readonly id: string;
      readonly isMember: boolean;
      readonly name: string;
      readonly visibility: SpaceVisibility;
      readonly " $fragmentSpreads": FragmentRefs<"spacePaywall_space">;
    };
  };
};
export type routeSpaceQuery = {
  response: routeSpaceQuery$data;
  variables: routeSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "space"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "space"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeSpaceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "spacePaywall_space"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeSpaceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isSpace"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentIntegrationProduct",
                "kind": "LinkedField",
                "name": "primaryProduct",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessDefaultDuration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "checkoutUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalProductAccessGroup",
                    "kind": "LinkedField",
                    "name": "accessGroup",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccessGroup",
                        "kind": "LinkedField",
                        "name": "accessGroup",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccessGroupCourse",
                            "kind": "LinkedField",
                            "name": "courses",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "course",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58520fbea66858fd2846db07af1c7b83",
    "id": null,
    "metadata": {},
    "name": "routeSpaceQuery",
    "operationKind": "query",
    "text": "query routeSpaceQuery(\n  $club: String!\n  $space: String!\n) {\n  club(slug: $club) {\n    space(slug: $space) {\n      __typename\n      id\n      name\n      visibility\n      isMember\n      ...spacePaywall_space\n    }\n    id\n  }\n}\n\nfragment spacePaywall_space on Space {\n  __isSpace: __typename\n  id\n  primaryProduct {\n    id\n    productName\n    accessDefaultDuration\n    description\n    checkoutUrl\n    basePrice\n    accessGroup {\n      accessGroup {\n        courses {\n          id\n          course {\n            name\n            id\n          }\n        }\n        spaces {\n          __typename\n          id\n          name\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a6fcbf5793bf96ee16264f58e93cf7d";

export default node;
